var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 1V2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3C2 3.26522 2.10536 3.51957 2.29289 3.70711C2.48043 3.89464 2.73478 4 3 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V16C20 16.5304 19.7893 17.0391 19.4142 17.4142C19.0391 17.7893 18.5304 18 18 18H11V11.414L12.293 12.707C12.4816 12.8892 12.7342 12.99 12.9964 12.9877C13.2586 12.9854 13.5094 12.8802 13.6948 12.6948C13.8802 12.5094 13.9854 12.2586 13.9877 11.9964C13.99 11.7342 13.8892 11.4816 13.707 11.293L10.707 8.293C10.6141 8.19987 10.5038 8.12599 10.3823 8.07557C10.2608 8.02516 10.1305 7.99921 9.999 7.99921C9.86747 7.99921 9.73722 8.02516 9.61573 8.07557C9.49424 8.12599 9.38389 8.19987 9.291 8.293L6.291 11.293C6.10884 11.4816 6.00805 11.7342 6.01033 11.9964C6.0126 12.2586 6.11777 12.5094 6.30318 12.6948C6.48859 12.8802 6.7394 12.9854 7.0016 12.9877C7.26379 12.99 7.5164 12.8892 7.705 12.707L9 11.414V18H2C1.46957 18 0.960859 17.7893 0.585786 17.4142C0.210714 17.0391 0 16.5304 0 16V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H19C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardInfo);
export default __webpack_public_path__ + "static/media/card-info.309785baa4b632067936cbf23915fb97.svg";
export { ForwardRef as ReactComponent };